const CSE_MESSAGES_API_PATH = "/cse_messages";

export const CSE_MESSAGES_API_ENDPOINTS = {
  GET_CSE_MESSAGES: CSE_MESSAGES_API_PATH,
  DISMISS_CSE_MESSAGE: `${CSE_MESSAGES_API_PATH}/:messageId/dismiss`,
};
